<template>
  <el-button type="primary" :disabled="isSend" @click="sendCodeFn">{{isSend ? sendTime + 's' : '发送验证码'}}</el-button>
</template>
<script> 
import { Button } from 'element-ui'
import { sendcode } from '@/services/user';
import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { checkPhone } from '@/utils/checkPhone';
import { mapState } from 'vuex';
export default {
  components: {
    ElButton: Button,
  },
  props: {
    phoneNum: {
      type: String,
    },
    errMsg: Array
  },
  data() {
    return {
      isSend: false,
      sendTime: 59,
      sendTimer: null,
      sending: false
    };
  },
  mounted() {
  },
  computed:{
    ...mapState({
      competitionId: state => state.router.id
    })
  },
  methods: {
    async sendCodeFn () {
      this.$emit('beforeSend')
      if(this.sending) return;
      const { phoneNum } = this
      if (!checkPhone(phoneNum)) {
        this.$emit('update:errMsg', ['请输入正确的手机号'])
        return
      } else {
        this.$emit('update:errMsg', [])
      }
      const p1 = phoneNum.substr(0, 3);
      const p2 = phoneNum.substr(8);
      const t = dayjs().format('YYYYMMDDHHmm');
      const ticket = CryptoJS
        .MD5(`${p1}${p2}${t}`)
        .toString();
      this.sending = true;
      try {
        await sendcode(
          {
            mobile: phoneNum+'',
            competitionId: this.competitionId,
          },
          { ticket: ticket }
        )
        this.sending = false;
        this.isSend = true;
        this.sendTimer = setInterval(()=>{
          this.sendTime--
          if(this.sendTime < 0) {
            clearInterval(this.sendTimer)
            this.sendTimer = null
            this.isSend = false
            this.sendTime = 59
          }
        },1000)
      } catch(e){
        this.$elMessage({
          message: (e && e.data && e.data.message) || '获取验证码失败',
          type: 'error'
        });
        this.sending = false;
        this.isSend = false
        this.sendTime = 59
      }
    },
  },
  beforeDestroy(){
    if (this.sendTimer) {
      clearInterval(this.sendTimer);
      this.sendTimer = null
    }
  }
}

</script>

<style lang="less" scoped>
/deep/ .el-button {
  width: 112px!important;
}
</style>